<template>
  <div class="privilege-card story">
    <div class="privilege-card__card bg-white">
      <div class="privilege-card__actions">
        <div>
          <a-select :value="selectedLanguage" size="small" @change="handleLangChange" class="lang-select">
            <a-select-option v-for="lang in langOptions" :key="lang.value">
              {{ lang.name }}
            </a-select-option>
          </a-select>
        </div>
        <div>
          <a-button
            type="link"
            :disabled="!editPermission"
            @click="openEditPage"
          >
            <a-icon
              type="edit"
              class="text-primary font-size-16"
            />
              Edit
          </a-button>
        </div>
      </div>
      <div class="privilege-card__content" @click="openFullInfoModal">
        <div v-if="selectedPreview.image">
          <img class="privilege-card__image" :src="selectedPreview.image.path" alt="" />
        </div>
        <div class="privilege-card__left" style="display: flex; flex-direction: column; gap: 0.5rem;">
          <div v-if="completionDateString">
            <div class="privilege-card--completion-date">
              {{ completionDateString }}
            </div>
          </div>
          <div>
            <div class="privilege-card--title">Title</div>
            <span class="privilege-card-title privilege-card--text">{{ selectedPreview.title }}</span>
          </div>
          <div v-if="selectedPreview.button_name">
            <div class="privilege-card--title">Button</div>
            <span class="privilege-card-title privilege-card--text">{{ selectedPreview.button_name }}</span>
          </div>
          <!-- <div>
            <div class="privilege-card--title">Apps</div>
            <div style="line-height: 2.1rem">
              <a-tag style="margin-right: 15px; padding: 1px 8px; border-radius: 2px"
                v-for="app in privilegeInfo.applications.slice(0, 2)" :key="app.id">
                {{ app.name }}
                <a-icon v-if="app.platform.toLowerCase() === 'android'" type="android" class="ml-1 text-success" />
                <a-icon v-if="app.platform.toLowerCase() === 'ios'" type="apple" class="ml-1 text-primary" />
                <a-icon v-if="app.platform.toLowerCase() === 'web'" type="global" class="ml-1 text-default" />
              </a-tag>
              <a-tag v-if="privilegeInfo.applications.length > 2">
                ...
              </a-tag>
            </div>
          </div> -->
        </div>
      </div>
      <div class="privilege-card__footer">
        <div class="d-flex align-items-center" :class="{'privilege-card__footer--inf' : !this.privilegeInfo.periods[0].ends_at}">
          <div class="text-uppercase mr-auto">
            {{ formatDate(privilegeInfo.periods[0].starts_at) }} -
            <span v-if="privilegeInfo.periods[0].ends_at">{{ formatDate(privilegeInfo.periods[0].ends_at) }}</span>
            <span v-else style="font-size: 20px;">&infin;</span>
          </div>
          <div class="d-flex">
            <a-switch :default-checked="Boolean(privilegeInfo.is_active)" @change="(val) => $emit('activeSwitch', val, privilegeInfo.uuid)" :disabled="!editPermission" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import 'dayjs/locale/ru'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru')

export default {
  name: 'Privilege-card',
  props: {
    privilegeInfo: {
      type: Object,
    },
    editPermission: {
      type: Boolean,
    },
    languages: {
      type: Array,
    },
  },
  data: () => ({
    selectedLanguage: 'ru',
    addToViewscreen: false,
  }),
  computed: {
    langOptions() {
      const langIds = this.privilegeInfo.localizations.map(l => l.lid)

      return this.languages.filter(language => langIds.includes(language.id)).map(language => ({
        name: language.desc,
        value: language.name,
      }))
    },
    selectedLanguageId() {
      return this.languages.find(l => l.name === this.selectedLanguage)?.id
    },
    selectedPreview() {
      return this.privilegeInfo.localizations.find(l => l.lid === this.selectedLanguageId)
    },
    completionDateString() {
      const isoDate = this.selectedPreview.completion_at

      if (!isoDate) {
        return null
      }

      const date = dayjs.utc(isoDate).tz('Europe/Moscow')
      const hour = date.hour()
      const minute = date.minute()

      if ((hour === 0 || hour === 3) && minute === 0) {
        return `до ${date.format('D MMMM')}`
      } else {
        return `до ${date.format('D MMMM')} в ${date.format('HH:mm')}`
      }
    },
  },
  watch: {
  },
  created() {
    // const langKeys = Object.keys(this.privilegeInfo.preview)
    // this.languages = langKeys.map((lang) => {
    //   return {
    //     name: lang,
    //     desc: lang,
    //   }
    // })
    // this.selectedLanguage = this.languages[0].desc
  },
  methods: {
    openFullInfoModal() {
      this.$emit('openFullInfo')
    },
    openEditPage() {
      this.$emit('openEdit')
    },
    formatDate: function (date) {
      return this.$moment(date).format('DD.MM.YY HH:mm')
    },
    handleLangChange(selectedLangKey) {
      this.selectedLanguage = selectedLangKey
    },
  },
}
</script>

<style lang="scss" src="./style.module.scss" />
